import { sanitiseUrlForEnvironment, trimTrailingSlash, useTenant } from '@parcel2go/npm-p2g-app';
import { useMemo } from 'react';
import { PublicSettings } from '~/lib/ui-serverless-settings';

export default function QuoteCardServiceLogo({
  slug,
  dataTestId,
  width,
  minWidth,
  height
}: {
  slug: string;
  dataTestId?: string;
  width?: number | string;
  minWidth?: number | string;
  height?: number | string;
}) {
  const { settings, theme } = useTenant();

  const url = useMemo(() => {
    const logoRoot = trimTrailingSlash(settings[PublicSettings.BASEURL] || theme?.p2g?.websiteRoot);
    return sanitiseUrlForEnvironment(`${logoRoot}/api/uis/v5/logo/service-logo?slug=${slug}`);
  }, [settings, slug, theme?.p2g?.websiteRoot]);

  return (
    <img
      fetchPriority="low"
      loading="lazy"
      src={url}
      style={{ maxWidth: minWidth ?? '100%' }}
      alt={slug}
      data-testid={dataTestId}
      width={width}
      height={height}
    />
  );
}
